module.exports = __webpack_public_path__ + "static/media/carol.65542574.mp3";